import * as tslib_1 from "tslib";
import { Component } from '@angular/core';
import { FieldType } from '../../../core';
var SelectOption = (function () {
    function SelectOption(label, value, children) {
        this.label = label;
        this.value = value;
        this.group = children;
    }
    return SelectOption;
}());
export { SelectOption };
var FormlyFieldSelect = (function (_super) {
    tslib_1.__extends(FormlyFieldSelect, _super);
    function FormlyFieldSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FormlyFieldSelect.prototype, "labelProp", {
        get: function () { return this.to.labelProp || 'label'; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormlyFieldSelect.prototype, "valueProp", {
        get: function () { return this.to.valueProp || 'value'; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormlyFieldSelect.prototype, "groupProp", {
        get: function () { return this.to.groupProp || 'group'; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormlyFieldSelect.prototype, "selectOptions", {
        get: function () {
            var _this = this;
            var options = [];
            this.to.options.map(function (option) {
                if (!option[_this.groupProp]) {
                    options.push(option);
                }
                else {
                    var filteredOption = options.filter(function (filteredOption) {
                        return filteredOption.label === option[_this.groupProp];
                    });
                    if (filteredOption[0]) {
                        filteredOption[0].group.push({
                            label: option[_this.labelProp],
                            value: option[_this.valueProp],
                        });
                    }
                    else {
                        options.push({
                            label: option[_this.groupProp],
                            group: [{ value: option[_this.valueProp], label: option[_this.labelProp] }],
                        });
                    }
                }
            });
            return options;
        },
        enumerable: true,
        configurable: true
    });
    return FormlyFieldSelect;
}(FieldType));
FormlyFieldSelect = tslib_1.__decorate([
    Component({
        selector: 'formly-field-select',
        template: "\n    <select [formControl]=\"formControl\" class=\"form-control\" [formlyAttributes]=\"field\">\n      <option value=\"\" *ngIf=\"to.placeholder\">{{ to.placeholder }}</option>\n      <ng-container *ngFor=\"let item of selectOptions\">\n       <optgroup *ngIf=\"item.group\" label=\"{{item.label}}\">\n         <option *ngFor=\"let child of item.group\" [value]=\"child.value\" [disabled]=\"item.disabled\">\n           {{ child.label }}\n         </option>\n       </optgroup>\n       <option *ngIf=\"!item.group\" [value]=\"item.value\" [disabled]=\"item.disabled\">{{ item.label }}</option>\n      </ng-container>\n    </select>\n  ",
    })
], FormlyFieldSelect);
export { FormlyFieldSelect };
//# sourceMappingURL=select.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/types/select.js
// module id = 776
// module chunks = 3